export default __webpack_public_path__ + "static/favicon-d182e0769d11667f8761bc2e7b9a55ed.svg";